import React from 'react';
import { string } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';
import weSupport from '../images/weSupport.png';

const useStyles = makeStyles({
  containerText: {
    height: '100%',
    padding: '0 16px',
    color: '#fff',
  },
  text: {
    fontWeight: 'bold',
    '@media (max-width:1270px)': {
      fontWeight: 'normal',
      fontSize: '14px',
    },
    '@media (max-width:1150px)': {
      fontWeight: 'normal',
      fontSize: '13px',
    },
    '@media (max-width:1090px)': {
      fontWeight: 'normal',
      fontSize: '12px',
    },
    '@media (max-width:1030px)': {
      fontWeight: 'normal',
      fontSize: '11px',
    },
    '@media (max-width:600px)': {
      fontWeight: 'normal',
      fontSize: '1em',
      padding: '0 10px 0px 25px',
    },
  },
  textBlue: {
    color: '#0e2f50',
    fontWeight: 'bold',
    '@media (max-width:1270px)': {
      fontWeight: 'normal',
      fontSize: '14px',
    },
    '@media (max-width:1150px)': {
      fontWeight: 'normal',
      fontSize: '13px',
    },
    '@media (max-width:1090px)': {
      fontWeight: 'normal',
      fontSize: '12px',
    },
    '@media (max-width:1030px)': {
      fontWeight: 'normal',
      fontSize: '11px',
    },
    '@media (max-width:600px)': {
      fontWeight: 'normal',
      fontSize: '1em',
      padding: '0 10px 0px 25px',
    },
  },
});

const ImgCard = ({ image, text, color, textColor }) => {
  const classes = useStyles();
  const logo = image ? image : weSupport;

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item sm={6}>
        <img src={logo} alt="vow sustainability" />
      </Grid>
      <Grid item sm={6} alignContent="stretch" alignItems="stretch">
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.containerText}
          style={{ backgroundColor: color }}
        >
          <p className={textColor ? classes.textBlue : classes.text}>{text}</p>
        </Grid>
      </Grid>
    </Grid>
  );
};

ImgCard.propTypes = {
  text: string.isRequired,
  image: string.isRequired,
  color: string.isRequired,
};

export default ImgCard;
